import { QueueState, QueueViewModelKey } from '../models/QueueState';

export const useQueue = () => {
	return QueueState[QueueViewModelKey];
};
